import "./Home.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import RedefiningYourDentalExperience from "./sections/RedefiningYourDentalExperience";
import OurCareStandards from "./sections/OurCareStandards";
import TheSleepGap from "./sections/TheSleepGap";
import RealLifeResults from "./sections/RealLifeResults";
import WhyChooseUs from "./sections/WhyChooseUs";
import SecureYourSlot from "./sections/SecureYourSlot";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <ClinicHeader />
      <RedefiningYourDentalExperience />
      <OurCareStandards />
      <TheSleepGap />
      <RealLifeResults />
      <WhyChooseUs />
      <SecureYourSlot />
      <Footer />
    </div>;
}